import React from 'react';
import { inject } from 'mobx-react';

import blank from '~/common/images/img-icon-requirement-empty.svg';
import checked from '~/common/images/img-icon-requirement-success.svg';
import cross from '~/common/images/img-icon-requirement-alert.svg';
import Eye from '~/common/images/icon-pw-show@2x.svg';
import EyeClosed from '~/common/images/icon-pw-hide@2x.svg';

import Input from '~/common/components/Input';

import styles from './inputField.css';

@inject('formsStore')
export default class InputField extends React.Component {
    state = {
        isFocus: !!this.props.focus,
        showPW: false
    };

    setFocusState(e) {
        this.setState({ isFocus: true });
        if (this.props.onFocus) this.props.onFocus(e);
        if (this.props.password) this.props.formsStore.setPasswordFocus(true);
    }

    setBlurState(e) {
        this.setState({ isFocus: false });
        if (this.props.onBlur) this.props.onBlur(e);
    }

    validationIcon(requirement, error) {
        return requirement ? <img src={checked} />
            : error ? <img src={cross} />
                : <img src={blank} />;
    }

    togglePasswordVisibility() {
        this.setState({ showPW: !this.state.showPW });
    }

    render() {
        const { labelContent, id, label, error, hint, defaultValue, wrapperClass, warning, password, passwordFocus, requirement1, requirement2, requirement3 } = this.props;

        return (
            <div className={`${styles.wrapper} ${wrapperClass || ''} ${password ? styles.password : ''}`}>
                <Input
                    {...this.props}
                    onBlur={e => this.setBlurState(e)}
                    onFocus={e => this.setFocusState(e)}
                    type={password ? (this.state.showPW ? 'text' : 'password') : this.props.type}
                />
                <label className={`${styles.label} ${defaultValue ? styles.min : ''} ${error ? styles.error : ''} ${warning ? styles.warning : ''}`} htmlFor={id}>{label}</label>
                {password && <img
                    className={styles.eye} onClick={() => this.togglePasswordVisibility()}
                    src={this.state.showPW ? EyeClosed : Eye}
                /> }
                {error && !password && <div className={styles['error-message']}>{error}</div>}
                {hint && this.state.isFocus && <div className={styles.hint}>{hint}</div>}
                {warning && <div className={styles['warning-message']}>{warning}</div>}
                {password && passwordFocus &&
                <div className={styles.requirements}>
                    <span className={styles.subhead}>{labelContent.PasswordRequirements}:</span>
                    <span>{this.validationIcon(requirement1, error)} {labelContent.PasswordLengthRequirement}</span>
                    <span>{this.validationIcon(requirement2, error)} {labelContent.PasswordCharacterRequirement}</span>
                    <span>{this.validationIcon(requirement3, error)} {labelContent.PasswordNumberRequirement}</span>
                </div>
                }
            </div>
        );
    }
}
